module.exports = __webpack_public_path__ + "img/Flussfamilie.e2c507d1.svg";